import { Capacitor } from '@capacitor/core';

export const basename = Capacitor.isNativePlatform() ? "" : (process.env.PUBLIC_URL || "");

export const apiBaseURL = Capacitor.isNativePlatform()
    ? "https://custom-answer.com/api/v1/"
    : "/api/v1";
